import { createContext, useContext } from 'react';

const ACGridContext = createContext({
  handleContextMenuOptions: () => {},
  handleOnSelectRow: () => {},
  deleteGrid: () => {},
});

export const useACGridContext = () => useContext(ACGridContext);

export default ACGridContext;
